/* eslint-disable indent */
export function addItemToLocalStorage(product) {
  const existingCart = localStorage.getItem('cart');
  const cartItems = existingCart ? JSON.parse(existingCart) : [];

  const existingItem = cartItems.find((x) => x.id === product.id);
  if (existingItem) {
    const updatedItems = cartItems.map((x) => (x.id === product.id ? { ...x, qty: x.qty + 1 } : x));
    localStorage.setItem('cart', JSON.stringify(updatedItems));
  } else {
    const newItems = [...cartItems, { ...product, qty: 1 }];
    localStorage.setItem('cart', JSON.stringify(newItems));
  }
}

export function removeItemFromLocalStorage(product) {
  const existingCartItems = localStorage.getItem('cart');
  if (existingCartItems) {
    const cartItems = JSON.parse(existingCartItems);
    const existingItem = cartItems.find((x) => x.id === product.id);
    if (existingItem) {
      if (existingItem.qty === 1) {
        const updatedItems = cartItems.filter((x) => x.id !== product.id);
        localStorage.setItem('cart', JSON.stringify(updatedItems));
      } else {
        const updatedItems = cartItems.map((x) => (x.id === product.id ? { ...x, qty: x.qty - 1 } : x));
        localStorage.setItem('cart', JSON.stringify(updatedItems));
      }
    }
  }
}

export function removeAllThatItemFromLocalStorage(product) {
  const existingCartItems = localStorage.getItem('cart');
  if (existingCartItems) {
    const cartItems = JSON.parse(existingCartItems);
    const updatedItems = cartItems.filter((x) => x.id !== product.id);
    localStorage.setItem('cart', JSON.stringify(updatedItems));
  }
}

export function clearLocalStorage() {
  localStorage.removeItem('cart');
  window.location.reload();
}
